import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
/*import { Http, ResponseContentType, RequestOptions, Response } from '@angular/http';*/
import { environment } from '../../../environments/environment';
import { DatePipe } from '@angular/common';
import { Observable } from 'rxjs';
import { Router } from '@angular/router';
import * as momemt from 'moment';

import { AbstractControl, ValidationErrors } from '@angular/forms';
import { AuthenticationService } from '../auth/authentication.service';
import { map } from 'rxjs/operators';
import * as moment from 'moment';

@Injectable({
  providedIn: 'root'
})
export class ValidationService {

  constructor(private http: HttpClient, private datePipe: DatePipe, private router: Router,
    private authService: AuthenticationService) { }
  protected readonly BASE_URL: string = environment.base_url;
  WPSiteUrl = environment.WPsiteurl;
  IsinValid(value: any) {
    if (value === undefined || value === '' || value == null) {
      return true;
    }
    if (value.toString().trim().length <= 0) {
      return true;
    }
    if (!value) {
      return true;
    }
    return false;
  }
  IsValid(value: any) {
    return !this.IsinValid(value);
  }
  colorsList = ["#28A436", "#EC5555", "#F2BD66", "#5BC8AF", "#198fde", "#8647B3", "#e47220"];
  IsinValidPrice(value: any) {
    if (this.IsinValid(value) || value == 0) {
      return true;
    }
    return false;
  }
  isInvalidDropDown(value: any) {
    if (value === undefined || value == '0' || value == null) {
      return true;
    }
    return false;
  }

  IsDate(value: any) {
    if (value === '' || value === null || value == 'Invalid Date') { return false; }
    if (value != undefined) {
      const regexp = new RegExp(/^\d{2}\/\d{2}\/\d{4}$/);
      const isYes = regexp.test(value);
      return !isYes;
    }
    return false;
  }
  isSpecialCharacterExist(search: string): boolean {
    var searchfind: boolean;
    var format = /[!@#$%^&*()_+\-=\[\]{};"\\|<>\/?]/;
    searchfind = format.test(search);
    return searchfind;

  }
  onlyDecimal(event) {
    if (event.target.value == ".") {
      event.target.value = "";
    }
  }

  DecimalOnly(value) {
    if (value == null || value == ".") {
      return null;
    }
    return value;
  }
  commaFormat(x: any) {
    if (x != null) {
      var parts = x.toString().split(",");
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      return parts.join(",");

    }
  }
  getChartColor(index) {
    const colors = [' #6596D6 ', ' #67A7FA ', ' #1967CB ', ' #0D77FF ', ' #004298 ', ' #285CA1 ', ' #55759E ', ' #4788DC ', ' #5167EA ', ' #2B44D8 ', ' #7582CF ', ' #4354B9 ', ' #0F24A4 ', ' #1458E2 ', ' #3562BF ', ' #305297 ', ' #333286 ', ' #98C7FF ', ' #4886D8 ', ' #2C99D7 ', ' #157BB5 ', ' #0C6699 ', ' #49A1D3 ', ' #62BFF3 ', ' #51B5D1 ', ' #6186D3 ', ' #33C5DF ', ' #21A5BC ', ' #277583 ', ' #274183 ', ' #21459E ', ' #4674E6 ', ' #3355AA ', ' #596C9C ', ' #503C8D ', ' #6042BE ', ' #906CFF ', ' #B08CC8 ', ' #A374AE ', ' #B4658E ', ' #CA62DF ', ' #A264D9 ', ' #90B36C ', ' #6C963D ', ' #6AB16A ', ' #75D285 ', ' #B3BB66 ', ' #C77272 ', ' #D75555 ', ' #A34646 ']
    return colors[index];
  }

  removeLastCharacterFromString(str: string) {
    str = str.trim();
    return str.substring(0, str.length - 1);;
  }
  decimalCommaFormat(x: any) {
    if (x != null) {
      var parts = x.toString().split(".");
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      return parts.join(".")
    }
  }

  formatNumbers(x: any) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

  isEmail(search: string): boolean {
    let serchfind: boolean;
    // tslint:disable-next-line:max-line-length
    const regexp = new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
    serchfind = regexp.test(search);
    return serchfind;
  }

  isPhoneNumber(search: any) {
    let serchfind: boolean;
    const regexp = new RegExp(/^\d{10}$/);
    serchfind = regexp.test(search);
    return serchfind;
  }

  IsValidZipCode(zip) {
    const isValid = /^[0-9]{5}(?:-[0-9]{4})?$/.test(zip);
    if (isValid) {
      return true;
    } else {
      return false;
    }
  }
  isUrlValid(url) {
    //const isValid = /^(https?|s?ftp):\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i.test(url);
    //if (isValid) {
    //    return true;
    //} else {
    //    return false;
    //}

    var pattern = new RegExp('^(https?:\\/\\/)?' + // protocol
      '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
      '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
      '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
      '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
      '(\\#[-a-z\\d_]*)?$', 'i'); // fragment locator
    return !!pattern.test(url);
  }

  isBetween(value: number, min: number, max: number) {
    return value >= min && value <= max;
  }

  minLength(value: string, min: number) {
    if (value) {
      return false;
    }

    return value.length > min;
  }

  formatURL(url: string) {
    if (!this.IsinValid(url)) {
      if (!(url.includes('http://') || url.includes('https://'))) {
        url = 'http://' + url;
      }
    }
    return url;
  }

  isValidVimeoUrl(url: string): boolean {
    let id = false;
    $.ajax({
      url: 'https://vimeo.com/api/oembed.json?url=' + url,
      async: false,
      success: function (response) {
        if (response.video_id) {
          id = true;
        }
      }
    });
    return id;
  }
  applyClass(status: string) {
    if (status == 'Active') {
      return 'greentext';
    }
    else if (status == 'Inactive') {
      return 'inactivetext';
    }
    else if (status == 'On Hold' || status == 'Invited') {
      return 'onholdtext';
    }
    else if (status == 'Deleted') {
      return 'redtext';
    }
  }
  datetify(date: any): Date {
    if (date) {
      return new Date(date);
    } else {
      return new Date();
    }
  }

  utcify(date: Date): Date {
    if (date) {
      return new Date(date.toUTCString());
    } else {
      return new Date();
    }
  }
  getSelectedOptionText(event: Event) {
    let selectElementText = event.target['options']
    [event.target['options'].selectedIndex].text;
    return selectElementText;
  }
  IsNull(val) {
    if (val == null || val == "0") {
      return '';
    }
    return val;
  }
  IsNullThen(val, newValue) {
    if (val == null) {
      val = newValue;
    }
    return val;
  }
  IsNullOrEmptyThen(val, newValue) {
    if (val == null || val == '') {
      val = newValue;
    }
    return val;
  }
  IsNullAndAddPrefix(val, newValue = '', prefix) {
    if (val == null) {
      val = newValue;
    }
    if (val != '') {
      val = prefix + val;
    }
    return val;
  }
  public IsNullAndAddSuffix(val, newValue = '', sufix) {
    if (val == null) {
      val = newValue;
    }
    if (val != '') {
      val = val + sufix;
    }
    return val;
  }
  public IsNullAndAddPrefixAndSuffix(val, newValue = '', prefix, sufix) {
    if (val == null) {
      val = newValue;
    }
    if (val != '') {
      val = prefix + val + sufix;
    }
    return val;
  }


  displayFirstThreeItems(currentValue: string) {
    let ItemToDisplay = ''
    if (currentValue) {
      let list = currentValue.split(',');
      let count = 0;
      list.forEach(item => {
        if (count < 3) {
          ItemToDisplay += item + ",";
        }
        count++;
      });
      ItemToDisplay = ItemToDisplay.slice(0, -1);
    }
    return ItemToDisplay;
  }
  displayRemainingItems(currentValue: string) {
    let ItemToDisplay = ''
    if (currentValue) {
      let brokers = currentValue.split(',');
      let count = 0;
      brokers.forEach(item => {
        if (count > 2) {
          ItemToDisplay += item + ",";
        }
        count++;
      });
      ItemToDisplay = ItemToDisplay.slice(0, -1);
    }
    return ItemToDisplay;
  }

  displayRemainingCount(currentValue: string) {
    let count = 0;
    let displayCount = 0;
    if (currentValue) {
      let list = currentValue.split(',');
      list.forEach(item => {
        if (count > 2) {
          displayCount++;
        }
        count++;
      });
    }
    return displayCount;
  }

  toLocalDate(date: Date) {
    this.convertUTCDateToLocalDate(date);
  }

  convertUTCDateToLocalDate(date: Date) {
    var newDate = new Date(date);
    var offset = newDate.getTimezoneOffset() / 60;
    var offsetTime = new Date(newDate.getTime() - (offset * 60 * 1000 * 60));
    return offsetTime;
  }
  convertDateToUTCStamp(dateToConvert) {
    let date = [];
    date = this.formatDate(this.convertUTCDateToLocalDate(new Date(dateToConvert)), "yyyy/M/dd").split('/');
    return Date.UTC(date[0], date[1] - 1, date[2]);
  }
  convertUTCDateToLocalDate1(date: Date) {
    var newDate = moment(date, "MM/DD/yyyy HH:mm:ss");
    var newDate1 = new Date(newDate.toDate());
    var offset = newDate1.getTimezoneOffset() / 60;
    var offsetTime = new Date(newDate1.getTime() - (offset * 60 * 1000 * 60));
    return offsetTime;
  }
  convertDateTimeToUTCStamp(dateToConvert) {
    let date = [];
    date = this.formatDate(this.convertUTCDateToLocalDate(new Date(dateToConvert)), "yyyy/M/dd").split('/');
    var time = this.formatDate(this.convertUTCDateToLocalDate(new Date(dateToConvert)), "HH:mm").split(':');
    return new Date(date[0], date[1] - 1, date[2], Number(time[0]), Number(time[1])).getTime();
  }
  formatDatetoMMDDYYYY(myDate) {
    try {
      return this.datePipe.transform(myDate, 'MM/dd/yyyy');
    } catch (error) {
      return '';
    }
  }

  formatDate(myDate, format: string) {
    return this.datePipe.transform(myDate, format); //whatever format you need.
  }

  addDays(date: Date, days: number): Date {
    //date.setDate(date.getDate() + (days));
    return this.DateAdd(date, days);
  }
  DateAdd(date: Date, days: number): Date {
    var newdate = new Date(date);
    newdate.setDate(newdate.getDate() + (days));
    return newdate;
  }

  openLinkInNewTab(url: string) {
    window.open(url, "_blank");
  }

  AddMinutesToDate(date: Date, minutes: number): Date {
    var newdate = new Date(date);
    newdate.setDate(newdate.getMinutes() + (minutes));
    return newdate;
  }

  DateDiff(date1: Date, date2: Date) {
    //Get 1 day in milliseconds
    var one_day = 1000 * 60 * 60 * 24;

    // Convert both dates to milliseconds
    var date1_ms = date1.getTime();
    var date2_ms = date2.getTime();

    // Calculate the difference in milliseconds
    var difference_ms = date2_ms - date1_ms;

    // Convert back to days and return
    return Math.round(difference_ms / one_day);
  }

  DateDiffInDays(date1: Date) {

    //Get 1 day in milliseconds
    var one_day = 1000 * 60 * 60 * 24;
    var date2 = new Date();
    // Convert both dates to milliseconds
    var date1_ms = date1.getTime();
    var date2_ms = date2.getTime();

    // Calculate the difference in milliseconds
    var difference_ms = date2_ms - date1_ms;

    // Convert back to days and return
    return Math.round(difference_ms / one_day);
  }

  getMinutesBetweenDates(date1: Date, date2: Date) {
    // Convert both dates to milliseconds
    var date1_ms = date1.getTime();
    var date2_ms = date2.getTime();

    // Calculate the difference in milliseconds
    var difference_ms = date2_ms - date1_ms;

    // Convert back to days and return
    return Math.round(difference_ms / 60000);
  }

  MonthAdd(date: Date, month: number): Date {
    var newdate = new Date(date);
    newdate.setMonth(newdate.getMonth() + (month));
    return newdate;
  }
  YearAdd(date: Date, year: number): Date {
    var newdate = new Date(date);
    newdate.setFullYear(newdate.getFullYear() + (year));
    return newdate;
  }

  getCurrentDate() {
    let currentDate = new Date();
    let dd: any = currentDate.getDate();
    let mm: any = currentDate.getMonth();
    let yr: any = currentDate.getFullYear();

    if (dd < 10) {
      dd = '0' + dd;
    }
    if (mm < 10) {
      mm = '0' + mm;
    }
    return Date.UTC(yr, mm, dd);
  }

  formatNumberToTwoDigit(number) {
    if (number < 10 && number > 0) {
      number = '0' + number;
    }
    return number;
  }
  ConvertToInt(val) {
    return parseInt(val);
  }
  getAllList(items: any[], field: string, value: string): any[] {
    if (!items) {
      return [];
    }
    return items.filter(singleItem => singleItem[field] === value);
  }
  deleteExcelFile(fileToDelete) {

    this.http.get(fileToDelete).subscribe(res => {

    });
  }
  getFileNameFromPath(filePath: string) {
    return filePath.split("/").pop();
  }
  getFileExtensionFromPath(filePath: string) {
    return filePath.split(".").pop();
  }
  downloadFile(filePathWithoutExtension, fileName) {
    ///
  }
  downloadExcelFile(filePathWithoutExtension, fileName) {
    let path = (this.BASE_URL + filePathWithoutExtension);
    this.getFile(path)
      .subscribe(fileData => {
        let b: any = new Blob([fileData], { type: 'application/octet-stream' });
        var url = window.URL.createObjectURL(b);
        var a = document.createElement('a')
        a.href = url;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        this.deleteExcelFile(this.BASE_URL + '/upload/deleteexcelfile/' + this.getFileNameFromPath(filePathWithoutExtension))
      });

  }
  downloadPDFFile(filePathWithoutExtension, fileName) {
    
    let path = (this.BASE_URL + filePathWithoutExtension);
    this.getFile(path)
      .subscribe(fileData => {
        let b: any = new Blob([fileData], { type: 'application/octet-stream' });
        var url = window.URL.createObjectURL(b);
        var a = document.createElement('a')
        a.href = url;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        this.deleteExcelFile(this.BASE_URL + '/upload/deletepdffile/' + this.getFileNameFromPath(filePathWithoutExtension));
      });

  }

  deletePdfFile(filePathWithoutExtension) {
    this.deleteExcelFile(this.BASE_URL + '/upload/deletepdffile/' + this.getFileNameFromPath(filePathWithoutExtension));
  }

  public getFile(path: string): Observable<any> {
    //let options = new RequestOptions({ responseType: ResponseContentType.Blob });
    //return this.httpRqst.get(path, options).pipe(map((response: Response) => <Blob><unknown>response.blob()));
    return this.http.get(path, { responseType: 'blob' }).pipe(
      map((response: Blob) => response)
    );
  }

  IsinValidPriceFormat(value: any) {
    if (value != "" && value == 0) {
      return true;
    }
    return false;
  }
  validateExpirationDate(arrayVal) {
    var isExpiryDateValidate: number[] = [];
    var currentDate: Date = new Date()
    currentDate.setHours(0, 0, 0, 0);
    for (let i = 0; i < arrayVal.length; i++) {
      var expiryDate: Date = new Date(arrayVal[i].ExpiryDate_Date)
      expiryDate.setHours(0, 0, 0, 0);
      if (currentDate > expiryDate) {
        isExpiryDateValidate[i] = 1;
      }
      else {
        isExpiryDateValidate[i] = 0;
      }
    }
    return isExpiryDateValidate;
  }

  formatCurrencyValues(value) {
    // Nine Zeroes for Billions
    if (!isNaN(value)) {
      value = Math.abs(Number(value)) >= 1.0e+12
        ? Math.abs(Number(value)) / 1.0e+12 + "T"
        : Math.abs(Number(value)) >= 1.0e+9
          ? Math.abs(Number(value)) / 1.0e+9 + "B"
          : Math.abs(Number(value)) >= 1.0e+6
            ? Math.abs(Number(value)) / 1.0e+6 + "M"
            : Math.abs(Number(value)) >= 1.0e+3
              ? Math.abs(Number(value)) / 1.0e+3 + "K"
              : Math.abs(Number(value));

      let lastChar = value.toString().charAt(value.length - 1);
      value += '';
      var x = value.split('.');
      var x1 = x[0];
      var x2 = x.length > 1 ? '.' + x[1] : '';
      return value = x1 + x2.substr(0, 2) + ((isNaN(lastChar) && value.indexOf('.') > -1) ? lastChar : '');
    }
    else {
      return value;
    }
  }

  navigateByUrl(link) {
    this.router.navigateByUrl(link);
  }
  getTaskPhaseName(id, name) {
    let val = "";
    switch (id) {
      case 2300: {
        val = "LOI - Offer Negotiations";
        break;
      }
      case 2301: {
        val = "PSA - PSA Negotiation";
        break;
      }
      case 2302: {
        val = "DD - Due Diligence";
        break;
      }
      case 2303: {
        val = "HC - Hard Contract";
        break;
      }
      case 2304: {
        val = "Closed - Closing Period";
        break;
      }
      case 350: {
        val = "PM - Pre Marketing";
        break;
      }
      default: {
        val = name;
        break;
      }
    }
    return val;
  }
  colorPicker(lowdate: any, highdate: any, currentDate: any, status: number, callId: number = 0) {
    if (callId == 0) {
      if (status == 1) {
        return "#5bc7af";
      }
      if (status == 0 && (currentDate > highdate)) {
        return "#F05F5F";
      }
      if (currentDate > highdate) {
        return "#5bc7af";
      }
      else if ((currentDate <= highdate) && (currentDate >= lowdate)) {
        return "#efc36d";
      }
      else if (currentDate < highdate) {
        return "#cccccc";
      }
    }
    else if (callId == 1) {
      if (status == 1) {
        return "#5BB1EE";
      }
      if (status == 0 && (currentDate > highdate)) {
        return "#5BB1EE";
      }
      if (currentDate > highdate) {
        return "#345D79";
      }
      else if ((currentDate <= highdate) && (currentDate >= lowdate)) {
        return "#345D79";
      }
      else if (currentDate < highdate) {
        return "#cccccc";
      }
    }
  }
  toYearMonthConverter(valuex: number | string, abbr?: boolean): string {

    if (!valuex) {
      return '-';
    }

    const value = parseFloat(valuex.toString());

    // (int)Math.Floor(x.LeaseExpiration.Value.Subtract(DateTime.Now).Days / (365.25 / 12))
    const months = Math.floor((value / (365.25 / 12))); // actual months

    const years = Math.floor(months / 12);

    const yrs = years > 1 ? (abbr ? 'yrs' : 'years') : (abbr ? 'yr' : 'year');
    const mnts = (months % 12) > 1 ? (abbr ? 'mo' : 'months') : (abbr ? 'mo' : 'month');

    const days = +valuex > 1 ? 'days' : (abbr ? 'd' : 'day');

    if (years > 0 && (months % 12) === 0) {
      return `${years} ${yrs}`;
    } else if (years === 0 && (months % 12) > 0) {
      return `${(months % 12)} ${mnts}`;
    } else if ((years < 1 && months < 1) || (years === 0 && months === 0)) {

      if (years === 0 && months === 0 && +valuex > 0) {
        return `${valuex} ${days}`;
      }

      return `Expired`;
    } else {
      return `${years} ${yrs} & ${(months % 12)} ${mnts}`;
    }
  }

  IsDateGreater(date1: Date, date2: Date) {
    const d1 = momemt(date1);
    const d2 = momemt(date2);
    return date1 > date2;
  }

  daysBetweenDates(value: Date, date2?: Date) {
    const d1 = momemt(value);
    const d2 = momemt(date2);

    const days = d1.diff(d2, 'days', false);
    return days;
  }

  yearsGapBetweenDates(value: Date, date2?: Date, precise?: boolean): string {
    if (!value || !date2) {
      return null;
    }

    const d1 = momemt(value);
    const d2 = momemt(date2);

    const years = d1.diff(d2, 'year', precise ? precise : false);
    const months = (d1.diff(d2, 'month', precise ? precise : false)) % 12;
    const yrs = years > 1 ? 'Years' : 'Year';
    const mnts = months > 1 ? 'Months' : 'Month';
    const ndays = d1.diff(d2, 'days', precise ? precise : false);
    const days = ndays > 1 ? 'days' : 'day';

    if (years === 0 && months > 0) {
      return `${months} ${mnts}`;
    }
    if (months > 0) {
      return `${years} ${yrs} & ${months} ${mnts}`;
    }
    else if ((years < 1 && months < 1) || (years === 0 && months === 0)) {
      if (years === 0 && months === 0 && ndays > 0) {
        return `${ndays} ${days}`;
      }
      return `Expired`;
    }
    return `${years} ${yrs}`;

  }

  YearMonthDaysBetweenDates(value: Date, date2?: Date, precise?: boolean): string {
    
    if (!value || !date2) {
      return null;
    }
    const d1 = momemt(value);
    const d2 = momemt(date2);
    const years = d1.diff(d2, 'year', precise ? precise : false);
    const months = (d1.diff(d2, 'month', precise ? precise : false)) % 12;
    const ndays = d1.diff(d2, 'days', precise ? precise : false);

    if (years === 0 && months > 0) {
      return `0|${months}|0`;
    }
    else if (years > 0 && months === 0) {
      return `${years}|0|0`;
    }
    if (months > 0) {
      return `${years}|${months}|0`;
    }
    else if ((years < 1 && months < 1) || (years === 0 && months === 0)) {
      if (years === 0 && months === 0 && ndays > 0) {
        return `0|0|${ndays}`;
      }
    }
  }

  ExcatYearMonthDaysBetweenDates(value: Date, date2?: Date, precise?: boolean): string {
    if (!value || !date2) {
      return null;
    }

    const d1 = momemt(value);
    const d2 = momemt(date2);
   
    const years = d1.diff(d2, 'year', precise ? precise : false) > 0 ? d1.diff(d2, 'year', precise ? precise : false) : 0;
    const months = (d1.diff(d2, 'month', precise ? precise : false)) % 12 > 0 ? (d1.diff(d2, 'month', precise ? precise : false)) % 12 : 0;
    d2.add(years, 'years').add(months, 'months');
    const ndays = d1.diff(d2, 'days', precise ? precise : false) > 0 ? d1.diff(d2, 'days', precise ? precise : false) : 0;

    return `${years}|${months}|${ndays}`;
  }

  DateNow() {
    let today = new Date();
    var dd = String(today.getDate()).padStart(2, '0');
    var mm = String(today.getMonth() + 1).padStart(2, '0');
    var yyyy = today.getFullYear();
    today = new Date(mm + '/' + dd + '/' + yyyy);
    return today;
  }
  getRemainingTerm(expirationDate: Date, commencementDate: Date) {
    // this method is used in prop-remaining-term pipe
    // expirationDate = this.convertUTCDateToLocalDate(expirationDate);
    // commencementDate = this.convertUTCDateToLocalDate(commencementDate);
    const currentDate = momemt(new Date(Date.now()).toISOString());

    if (!expirationDate) {
      return '-';
    }
    if (!commencementDate) {
      return '-';
    }

    const $expDate = momemt(expirationDate);
    const $commencementDate = momemt(commencementDate);
    const originalTerm = $expDate.diff($commencementDate, 'years', false);

    if (commencementDate > new Date(Date.now())) {
      return this.yearsGapBetweenDates(expirationDate, commencementDate);
    }
    else {
      return this.yearsGapBetweenDates(expirationDate, this.DateNow());
    }

    //const years = $expDate.diff(currentDate, 'years', false);
    //const ndays = Math.ceil($expDate.diff(currentDate, 'days', true));
    //const months = ($expDate.diff(currentDate, 'month', false)) % 12;
    //console.log(($expDate.diff(currentDate, 'month', false)));

    //const days = ndays > 1 ? 'days' : 'day';
    //const yrs = years > 1 ? 'Years' : 'Year';
    //const mnts = months > 1 ? 'Months' : 'Month';

    //if (years === 0 && months > 0) {
    //    return `${months} ${mnts}`;
    //} else if (years > 0 && months === 0) {
    //    return `${years} ${yrs}`;
    //} else if ((years < 1 && months < 1) || (years === 0 && months === 0)) {

    //    if (years === 0 && months === 0 && ndays > 0) {
    //        return `${ndays} ${days}`;
    //    }

    //    return `Expired`;
    //} else {
    //    return `${years} ${yrs} & ${months} ${mnts}`;
    //}
  }

  remainingTermForCardandTables(LeaseExpiration_Date, LeaseCommencement_Date) {
    if (this.IsinValid(LeaseExpiration_Date) || this.IsinValid(LeaseCommencement_Date)) {
      return '-';
    }
    let LeaseCommencementDate = this.convertUTCDateToLocalDate(LeaseCommencement_Date);
    let LeaseExpirationDate = this.convertUTCDateToLocalDate(LeaseExpiration_Date);
    let Remaining_Term = this.getRemainingTerm(LeaseExpirationDate, LeaseCommencementDate);
    return Remaining_Term.replace('Years', 'yrs').replace('Year', 'yr').replace('Months', 'mo').replace('Month', 'mo');
  }

  getRemainingTermHistory(expirationDate: Date, commencementDate: Date) {
    // this method is used in prop-remaining-term pipe
    // expirationDate = this.convertUTCDateToLocalDate(expirationDate);
    // commencementDate = this.convertUTCDateToLocalDate(commencementDate);
    const currentDate = momemt(new Date(Date.now()).toISOString());

    if (!expirationDate) {
      return '-';
    }
    if (!commencementDate) {
      return '-';
    }

    const $expDate = momemt(expirationDate);
    const $commencementDate = momemt(commencementDate);

    return this.ExcatYearMonthDaysBetweenDates(expirationDate, commencementDate);

    // commented as currently client want to see remaining term based on sale added date (OP - 254715).
    //if (commencementDate > new Date(Date.now())) {
    //  return this.ExcatYearMonthDaysBetweenDates(expirationDate, commencementDate);
    //}
    //else {
    //  return this.ExcatYearMonthDaysBetweenDates(expirationDate, this.DateNow());
    //}

  }



  stuff(stringArray: Array<string>[]) {
    let result = "";
    stringArray.forEach(item => {
      result += item;
    });
    return result;
  }
  paramReplace(name, string, value) {
    // Find the param with regex
    // Grab the first character in the returned string (should be ? or &)
    // Replace our href string with our new value, passing on the name and delimeter

    var re = new RegExp("[\\?&]" + name + "=([^&#]*)");
    var matches = re.exec(string);
    var newString;

    if (matches === null) {

      if (string.indexOf('?') == -1) {
        // if there are no params, append the parameter
        newString = string + '?' + name + '=' + value;
      }
      else {
        newString = string + '&' + name + '=' + value;
      }
    } else {
      var delimeter = matches[0].charAt(0);
      newString = string.replace(re, delimeter + name + "=" + value);
    }
    return newString;
  }

  removeNotAvailableStatusFromPropertyStatus(inputPropertyStatus: any) {
    let removeNotAvailbaleStatus: boolean = true;
    if (this.authService.user !== null) {
      if (this.authService.IsUserRole(this.authService.UserRole.Admin) || this.authService.IsUserRole(this.authService.UserRole.SuperAdmin) || this.authService.IsUserRole(this.authService.UserRole.Broker) || this.authService.IsUserRole(this.authService.UserRole.DataEntryStaff)) {
        removeNotAvailbaleStatus = false;
      }
      else {
        removeNotAvailbaleStatus = true;
      }
    }
    else {
      removeNotAvailbaleStatus = true;
    }
    if (removeNotAvailbaleStatus) {
      inputPropertyStatus.splice(inputPropertyStatus.findIndex(x => x.id == 355), 1);
    }
  }

  hasAccess(GroupName: string, Name: string) {
    return true;
    //if (this.authService.IsUserRole(this.authService.UserRole.Admin)) {
    //    return true;
    //}

    //let permissions: IPermission[] = JSON.parse(localStorage.getItem("MenuPermissions"));
    //if (permissions) {
    //    let hasPermission = permissions.find(x => x.GroupName == GroupName && x.Name == Name);
    //    if (hasPermission) {
    //        return hasPermission.HasPermission;
    //    }
    //    else {
    //        return false;
    //    }
    //}
    //else {
    //    return false;
    //}
  }

  IfNoAccessThenRedirect(GroupName: string, Name: string) {
    return true;
    //if (!this.authService.IsUserRole(this.authService.UserRole.Admin)) {
    //    if (!this.hasAccess(GroupName, Name)) {
    //        this.router.navigate(['/']);
    //    }
    //}
  }

  getIPAddress() {
    return this.http.get("https://api.ipify.org/?format=json");
  }
  redirect(urlPart: string, actualUrl = null,isLoggedIn: boolean = true) {
    if (urlPart == '/' && this.IsinValid(actualUrl) && isLoggedIn) {
      this.router.navigate(['']);
    }
    else if (!this.IsinValid(this.WPSiteUrl)) {
      window.location.href = this.WPSiteUrl + urlPart;
    }
    else {
      if (this.IsinValid(actualUrl)) {
        actualUrl = urlPart;
      }
      this.router.navigateByUrl(actualUrl);
    }
  }
  scrollTop() {
   // $('html,body').animate({ scrollTop: 0 }, 500);
  }
  scrollToElement(elementId, offset) {
    var element = document.getElementById(elementId);
   // $('html,body').animate({ scrollTop: ($(element).offset().top - offset) }, 500);
  }

  refreshPage(currentPageUrl: string) {
    this.router.navigateByUrl("redirect?url=" + encodeURIComponent(currentPageUrl));
  }

  formatNumberForGraph(pointy) {
    let value = pointy;
    value += '';
    var x = value.split('.');
    var x1 = x[0];
    var x2 = x.length > 1 ? '.' + x[1] : '';
    var rgx = /(\d+)(\d{3})/;
    while (rgx.test(x1)) {
      x1 = x1.replace(rgx, '$1' + ',' + '$2');
    }
    return x1 + x2;
  }

  updateQueryStringParameter(uri, key, value) {
    var re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
    var separator = uri.indexOf('?') !== -1 ? "&" : "?";
    if (uri.match(re)) {
      return uri.replace(re, '$1' + key + "=" + value + '$2');
    }
    else {
      return uri + separator + key + "=" + value;
    }
  }

  changeQueryStringValue(paramName: string, value: string, url?: string) {
    if (this.IsinValid(url)) {
      url = this.router.url;
    }
    let redirectUrl = decodeURIComponent(url);
    let splitUrl = redirectUrl.split('?');
    redirectUrl = splitUrl[0] + "?" + (splitUrl.length > 1 ? splitUrl[1] : '');
    redirectUrl = this.updateQueryStringParameter(redirectUrl, paramName, value);
    return redirectUrl;
  }

  removeURLParameter(parameter, url) {
    //prefer to use l.search if you have a location/link object
    var urlparts = url.split('?');
    if (urlparts.length >= 2) {

      var prefix = encodeURIComponent(parameter) + '=';
      var pars = urlparts[1].split(/[&;]/g);

      //reverse iteration as may be destructive
      for (var i = pars.length; i-- > 0;) {
        //idiom for string.startsWith
        if (pars[i].lastIndexOf(prefix, 0) !== -1) {
          pars.splice(i, 1);
        }
      }

      url = urlparts[0] + '?' + pars.join('&');
      return url;
    } else {
      return url;
    }
  }

  GetAuthHeader() {
    //when ever make changes in this method pls make same changes in RestService.ts 's same method
    let token = '';
    let token_Expiry = localStorage.getItem("auth_token_expiry");
    var user = JSON.parse(localStorage.getItem("currentUser"));
    if (user != null && (!token_Expiry || new Date(token_Expiry) < new Date())) {
      console.log('token_Expiry=' + token_Expiry);
      localStorage.setItem('auth_token_expiry', this.GetTokenExpiryDate().toString());
      let date = token_Expiry;

      this.http.get('user/refreshToken/' + user.Id).subscribe(res => {
        localStorage.setItem('auth_token', res.toString());
        return this.setToken(token);
      }, error => {
        localStorage.setItem('auth_token_expiry', date);
      });
    }
    else {
      return this.setToken(token);
    }
  }

  setToken(token) {
    if (localStorage.getItem("auth_token") !== null) {
      token = localStorage.getItem('auth_token');
    }

    const httpOptions = {
      headers: new HttpHeaders({
        "Authorization": "Bearer " + token
      })
    };
    return httpOptions;
  }
  GetTokenExpiryDate() {
    return this.DateAdd(new Date(), environment.jwtTokenExpiry);
  }
}

export function spaceOnlyValidator(c: AbstractControl): ValidationErrors {
  if (c.value === '' || c.value === null) { return null; }
  const isYes = c.value.trim().length === 0 ? true : false;
  return isYes ? { 'spaceOnly': { value: 'The value cannot be only white spaces' } } : null;
}
export function EmailValidator(c: AbstractControl): ValidationErrors {
  if (c.value === '' || c.value === null) { return null; }
  if (c.value != undefined) {
    const regexp = new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
    const isYes = regexp.test(c.value);
    return !isYes ? { 'EmailCheck': { value: 'Invalid Email Address' } } : null;
  }
  return null;
}

export function DateValidator(c: AbstractControl): ValidationErrors {
  if (c.value === '' || c.value === null || c.value == 'Invalid Date') { return null; }
  if (c.value != undefined) {
    const regexp = new RegExp(/^\d{2}\/\d{2}\/\d{4}$/);
    const isYes = regexp.test(c.value);
    return isYes ? { 'DateCheck': { value: 'Invalid Date' } } : null;
  }
  return null;
}

export function dropdownItemSelected(c: AbstractControl): ValidationErrors {
  if (c.value === '' || c.value === null) { return null; }
  return c.value === 0 ? { 'defaultSelected': true } : null;
}
